import { Datasource } from '@/shared/types/collections';

import { DATASOURCE_TYPE_TO_TAB, ROOT_DATASOURCE_NAMES } from '../constants';

export const documentLink = (
  slug: string,
  collectionId: string,
  datasourceId: string,
  documentId: string,
  datasource: Datasource
): string => {
  const category = DATASOURCE_TYPE_TO_TAB[datasource.type];
  const hash = `document-${documentId}`;
  const isRoot = !!(Object.values(ROOT_DATASOURCE_NAMES) as string[]).includes(datasource.name);

  if (category === 'webpages' || category === 'external') {
    return `/${slug}/knowledge-bases/${collectionId}/category/${category}/${datasourceId}#${hash}`;
  }
  const folder = isRoot ? '' : datasourceId;
  return `/${slug}/knowledge-bases/${collectionId}/category/${category}/${folder}#${hash}`;
};
